import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Third party
import { NgSelectModule } from '@ng-select/ng-select';
import { PrettyJsonModule } from 'angular2-prettyjson';

// Local
import { BasicProcessConfigurationComponent } from './basic-process-configuration.component';
import { BtnTriggerComponent } from './btn-trigger/btn-trigger.component';
import { ManageDocumentComponent } from './manage-document/manage-document.component';
import { ManageFunctionComponent } from './manage-function/manage-function.component';
import { DuplicateProcessComponent } from './duplicate-process/duplicate-process.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ManagementCheckListFormComponent } from './management-check-list-form/management-check-list-form.component';
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';
import { ManageTitlesComponent } from './manage-titles/manage-titles.component';
import { NotifierService } from '@app/shared/services/notifier.service';
import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    PrettyJsonModule,
    ScrollToModule,
    CollapseModule,
    SharedAdministrationModule
  ],
  declarations: [
    BasicProcessConfigurationComponent,
    BtnTriggerComponent,
    ManageDocumentComponent,
    ManageFunctionComponent,
    DuplicateProcessComponent,
    ManagementCheckListFormComponent,
    ManageTitlesComponent
  ],
  exports: [
    BasicProcessConfigurationComponent,
    BtnTriggerComponent,
    DuplicateProcessComponent
  ],
  providers: [NotifierService],
  entryComponents: [SelectTramiteComponent]
})
export class BasicProcessConfigurationModule { }



// WEBPACK FOOTER //
// ./src/app/administration/basic-process-configuration/basic-process-configuration.module.ts